import React, {useContext, useEffect, useState} from "react";
import {Route, Switch} from "react-router-dom";
import $ from "jquery";
import moment from "moment";
import packageJson from "../../../../../package.json";
import usePrevious from "../../../../class/tool/usePrevious";
import Line from "../../../table/Line";
import PreviewBox from "../sale/PreviewBox";
import Drawer from "./Drawer";
import MiniChart from "./MiniChart";
import DrawerHistory from "../automaticdrawer/DrawerHistory";
import Release270 from "../../../overbox/version/Release270";
import DashboardController from "../../../../stories/_statistic/Dashboard/DashboardController";
import AutomaticDrawerController from "../../../../stories/_setting/AutomaticDrawers/AutomaticDrawerController";
import DrawerEventEntryController from "../../../../stories/_legaldata/DrawerEventEntries/DrawerEventEntryController";
import BackofficeContext from "../../../../context/BackofficeContext";
import DashboardContext from "../../../../context/DashboardContext";
import "../../../../css/page/content/dashboard/Dashboard.css";
import "moment/locale/fr";

const Dashboard = () => {
    moment.locale("fr");
    const { setEvent } = useContext(BackofficeContext);
    const [ intervalStats, setIntervalStats ] = useState(null);
    const [ intervalDrawerEvents, setIntervalDrawerEvents ] = useState(null);
    const [ dashboard, setDashboard ] = useState(null);
    const [ dashboardSix, setDashboardSix ] = useState(null);
    const [ statsCASix, setStatsCASix ] = useState(null);
    const [ statsSalesSix, setStatsSalesSix ] = useState(null);
    const [ CA, setCA ] = useState(null);
    const [ nbSales, setNbSales ] = useState(null);
    const [ average, setAverage ] = useState(null);
    const [ listSales, setListSales ] = useState(null);
    const [ onTablet, setOnTablet ] = useState(false);
    const [ automaticDrawers, setAutomaticDrawers ] = useState([]);
    const [ lastDrawerEvents, setLastDrawerEvents] = useState([]);
    const [ dashboardContext, setDashboardContext ] = useState({});
    const [ releaseNotifDisplayed, setReleaseNotifDisplayed ] = useState(false);
    const prevCA = usePrevious(CA);
    const prevNbSales = usePrevious(nbSales);
    const prevAverage = usePrevious(average);
    const LOG = false;
    const INTERVAL_STATS = 120000;
    const INTERVAL_DRAWER_EVENTS = 30000;
    const EVOL_PERCENT = 15;
    const modelListSales = [
        {
            "class": "number",
            "attributes": ["number"],
            "type": "text"
        },
        {
            "class": "amount",
            "attributes": ["amountInclTax"],
            "type": "price"
        },
        {
            "class": "article",
            "attributes": ["nbArticle"],
            "type": "text"
        },
        {
            "class": "date",
            "attributes": ["created_at"],
            "type": "hour"
        }
    ];

    const init = () => {
        getAutomaticDrawers();
        getDashboard();
        getDashboardSix();
    }
    const clearIntervals = () => {
        if (intervalStats !== null)
            clearInterval(intervalStats)
    }
    const clearDrawerIntervals = () => {
        if (intervalDrawerEvents !== null)
            clearInterval(intervalDrawerEvents);
    }
    const resize = () => {
        let limitTablet = 1199;
        setOnTablet($(window).width() <= limitTablet);
    }
    const iCallStats = () => {
        if (dashboard === null || dashboardSix === null)
            return;

        callStats();
    }
    const getDashboard = () => {
        const dates = { begin: moment().startOf("day").format(), end: moment().endOf("day").format() };
        const controller = new DashboardController();
        controller._callback = returnGetDashboard;
        controller.index({
            dateType: "day",
            dates: dates,
            compare: null,
            withVersus: false,
            withSubPeriods: false
        });
    }
    const getDashboardSix = () => {
        const dates = { begin: moment().startOf("day").add(-5, 'days').format(), end: moment().startOf("day").format() };
        const controller = new DashboardController();
        controller._callback = returnGetDashboardSix;
        controller.index({
            dateType: "day",
            dates: dates,
            compare: null,
            withVersus: false,
            withSubPeriods: true
        });
    }
    const returnGetDashboard = (object, error, status) => {
        switch (status) {
            case 200:
                setDashboard(object);
                break
            default:
                setEvent({
                    type: "error",
                    text: "Une erreur s'est produite. Code [DASH-" + status + "]"
                });
                break;
        }
    }
    const returnGetDashboardSix = (object, error, status) => {
        switch (status) {
            case 200:
                setDashboardSix(object);
                break
            default:
                setEvent({
                    type: "error",
                    text: "Une erreur s'est produite. Code [DASH-" + status + "]"
                });
                break;
        }
    }
    const callStats = (launchInterval = false) => {
        if (dashboard === null || dashboardSix === null)
            return;

        const controllerNow = new DashboardController();
        controllerNow._callbackCA = returnGetCA;
        controllerNow._callbackLightSalesStats = returnGetSales;
        controllerNow._callbackSales = returnGetSalesList;
        controllerNow.get(dashboard, "ca");
        controllerNow.get(dashboard, "lightSalesStats");
        controllerNow.get(dashboard, "sales", 1, 6, "created_at", "desc");

        const controllerSix = new DashboardController();
        controllerSix._callbackCA = returnGetCASix;
        controllerSix._callbackLightSalesStats = returnGetSalesSix;
        controllerSix.get(dashboardSix, "ca");
        controllerSix.get(dashboardSix, "lightSalesStats");

        if (launchInterval) {
            const interval = setInterval(iCallStats, INTERVAL_STATS);
            setIntervalStats(interval);
        }
    }
    const returnGetCA = (object, error, status) => {
        switch (status) {
            case 200:
                try {
                    const result = object.date.period.datas;
                    setCA(result.inclTax);
                } catch (error) {
                    console.error("returnGetCA Error", error);
                }

                break
            default:
                setEvent({
                    type: "error",
                    text: "[CA-" + status + "]"
                });
                console.error("[CA-" + status + "]", error, object);
                break;
        }
    }
    const returnGetSales = (object, error, status) => {
        switch (status) {
            case 200:
                try {
                    const result = object.date.period.datas;
                    setNbSales(result.nb);
                    setAverage(result.averagePrice);
                }
                catch (error) {
                    console.error("returnGetSales Error", error);
                }

                break;
            default:
                setEvent({
                    type: "error",
                    text: "[SALE-" + status + "]"
                });
                console.error("[SALE-" + status + "]", error, object);
                break;
        }
    }
    const returnGetCASix = (object, error, status) => {
        switch (status) {
            case 200:
                setStatsCASix(object);
                break
            default:
                setEvent({
                    type: "error",
                    text: "[CA-SIX-" + status + "]"
                });
                console.error("[CA-SIX-" + status + "]", error, object);
                break;
        }
    }
    const returnGetSalesSix = (object, error, status) => {
        switch (status) {
            case 200:
                setStatsSalesSix(object);
                break
            default:
                setEvent({
                    type: "error",
                    text: "[SALE-SIX-" + status + "]"
                });
                console.error("[SALE-SIX-" + status + "]", error, object);
                break;
        }
    }
    const returnGetSalesList = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                setListSales(list);
                break;
            default:
                setEvent({
                    type: "error",
                    text: "[SALE-LIST-" + status + "]"
                });
                console.error("[SALE-LIST-" + status + "]", error, list);
                break;
        }
    }
    const controlNumbers = () => {
        if (prevCA === undefined) $("#CA").addClass("loading");
        else $("#CA").removeClass("loading");

        if (prevNbSales === undefined) $("#nbSales").addClass("loading");
        else $("#nbSales").removeClass("loading");

        if (prevAverage === undefined) $("#average").addClass("loading");
        else $("#average").removeClass("loading");

        evolDecimal("CA", CA, prevCA);
        evolInteger("nbSales", nbSales, prevNbSales);
        evolDecimal("average", average, prevAverage);
    }
    const evolDecimal = (id, value, prevValue) => {
        let prev, delta, step, loop;

        if (value !== null && prevValue !== undefined && parseFloat(value) !== parseFloat(prevValue)) {
            try {
                loop = 1;
                prev = prevValue !== null ? prevValue : 0;
                delta = Math.abs(Math.round((parseFloat(value) - parseFloat(prev)) * 100) / 100);
                step = Math.round(((EVOL_PERCENT * delta) / 100) * 100) / 100;

                if (LOG) console.log(id, value, prev, delta, step);
                if (Math.abs(delta) === 0) return;

                if (parseFloat(value) >= parseFloat(prev)) {
                    for (let i = parseFloat(prev); i <= parseFloat(value); i = Math.round((i + step) * 100) / 100) {
                        if (i > parseFloat(value))
                            i = parseFloat(value);

                        setTimeout(() => { $("#" + id + " > strong").text(new Intl.NumberFormat("de-DE", {minimumFractionDigits: 2}).format(i)); }, loop*100);

                        loop++;
                    }

                }
                else {
                    for (let i = parseFloat(prev); i <= parseFloat(value); i = Math.round((i - step) * 100) / 100) {
                        if (i < parseFloat(value))
                            i = parseFloat(value);

                        setTimeout(() => { $("#" + id + " > strong").text(new Intl.NumberFormat("de-DE", {minimumFractionDigits: 2}).format(i)); }, loop*100);

                        loop++;
                    }
                }

                setTimeout(() => { $("#" + id + " > strong").text(new Intl.NumberFormat("de-DE", {minimumFractionDigits: 2}).format(parseFloat(value))); }, loop*100);
            }
            catch (error) {}
        }
    }
    const evolInteger = (id, value, prevValue) => {
        let prev, delta, step, loop;

        if (value !== null && prevValue !== undefined && parseInt(value) !== parseInt(prevValue)) {
            try {
                loop = 1;
                prev = prevValue !== null ? prevValue : 0;
                delta = Math.abs(parseInt(value) - parseInt(prev));
                step = delta > 1 ? Math.round(((EVOL_PERCENT * delta) / 100)) : 1;

                if (delta > 0 && step === 0)
                    step = 1;

                if (LOG) console.log(id, value, prev, delta, step);
                if (Math.abs(delta) === 0) return;

                if (parseInt(value) >= parseInt(prev)) {
                    for (let i = parseInt(prev); i <= parseInt(value); i = i + step) {
                        if (i > parseInt(value))
                            i = parseInt(value);

                        setTimeout(() => { $("#" + id + " > strong").text(i); }, loop*100);

                        loop++;
                    }
                }
                else {
                    for (let i = parseInt(prev); i <= parseInt(value); i = i - step) {
                        if (i < parseInt(value))
                            i = parseInt(value);

                        setTimeout(() => { $("#" + id + " > strong").text(i); }, loop*100);

                        loop++;
                    }
                }

                setTimeout(() => { $("#" + id + " > strong").text(parseInt(value)); }, loop*100);
            }
            catch (error) {}
        }
    }
    const getAutomaticDrawers = () => {
        let controller = new AutomaticDrawerController();
        controller._callback = handleGetAutomaticDrawers;
        controller.index(null, null, null, true, "name", "asc");
    }
    const handleGetAutomaticDrawers = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                setAutomaticDrawers(list);
                break;
            default:
                console.error("[AUTOMATIC-DRAWER-" + status + "]", error, list);
                break;
        }
    }
    const getLastEvents = () => {
        const controller = new DrawerEventEntryController();
        controller._callback = returnGetLastEvents;
        controller.index(null, 25);
    }
    const returnGetLastEvents = (list, error, status) => {
        switch (status) {
            case 200:
                setLastDrawerEvents(list);
                break;
            default:
                console.error("LAST-DRAWER-EVENTS", list, error, status);
                break;
        }
    }
    const buildNotifVersion = () => {
        if (releaseNotifDisplayed) return;

        let releaseDate, displayed;

        switch (packageJson.version) {
            case "2.7.0":
                releaseDate = moment.utc("2026-03-16 00:00:00");
                displayed = localStorage.getItem("release270Displayed");

                if (displayed === null && Math.abs(releaseDate.diff(moment(), "days")) < 31)
                    return <Release270 close={closeReleaseNotif} />;
                else
                    setReleaseNotifDisplayed(true);

                break;
            default: break;
        }
    }
    const closeReleaseNotif = () => {
        localStorage.setItem("release" + packageJson.version.replaceAll(".", "") + "Displayed", true);
        setReleaseNotifDisplayed(true);
    }

    useEffect(() => {
        document.title = "Tableau de bord";

        window.addEventListener('resize', resize)
        resize();
        init();

        return () => window.removeEventListener('resize', resize)
    }, []);
    useEffect(() => {
        return() => {
            clearIntervals();
        }
    }, [intervalStats]);
    useEffect(() => {
        if (automaticDrawers.length > 0) {
            getLastEvents();

            const interval = setInterval(getLastEvents, INTERVAL_DRAWER_EVENTS);
            setIntervalDrawerEvents(interval);
        }
    }, [automaticDrawers]);
    useEffect(() => {
        return() => {
            clearDrawerIntervals();
        }
    }, [intervalDrawerEvents]);
    useEffect(() => {
        if (dashboard !== null && dashboardSix !== null)
            callStats(true);
    }, [dashboard, dashboardSix]);
    useEffect(() => {
        controlNumbers();
    }, [CA, nbSales, average]);
    useEffect(() => {
        setDashboardContext(prev => ({
            ...prev,
            lastDrawerEvents
        }))
    }, [lastDrawerEvents]);

    return(
        <DashboardContext.Provider value={dashboardContext}>
            <div className="main paddingBottom">
                { buildNotifVersion() }
                <div className={"wrapStats"}>
                    <div className={"keyStat"}>
                        <div className={"containerValue"}>
                            <p className={"titleStat"}>Chiffre d'affaires</p>
                            <p className={"valueStat loading"} id={"CA"}><strong>0,00</strong><em>€</em></p>
                        </div>
                        <MiniChart idChart={"chartCA"} onTablet={onTablet} datas={statsCASix} />
                    </div>
                    <div className={"keyStat"}>
                        <div className={"containerValue"}>
                            <p className={"titleStat"}>Nb. de ventes</p>
                            <p className={"valueStat loading"} id={"nbSales"}><strong>0</strong></p>
                        </div>
                        <MiniChart idChart={"chartNbSales"} onTablet={onTablet} datas={statsSalesSix} />
                    </div>
                    <div className={"keyStat noRight"}>
                        <div className={"containerValue"}>
                            <p className={"titleStat"}>Panier moyen</p>
                            <p className={"valueStat loading"} id={"average"}><strong>0,00</strong><em>€</em></p>
                        </div>
                        <MiniChart idChart={"chartAverage"} onTablet={onTablet} datas={statsSalesSix} />
                    </div>
                </div>
                <div className={"containerModules"}>
                    {
                        automaticDrawers.map((automaticDrawer, index) => <Drawer automaticDrawer={automaticDrawer} key={index} />)
                    }
                    <div className={"module dual" + (listSales === null ? " loading" : "")}>
                        <div className={"titleModule"}><p>Dernières ventes</p></div>
                        <table>
                            <thead>
                            <tr>
                                <th className={"number"}>#</th>
                                <th className={"amount"}>Montant</th>
                                <th className={"article"}>Articles</th>
                                <th className={"date"}>Heure</th>
                                <th className={"access"}></th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                listSales !== null && listSales.length > 0
                                    ? listSales.map((sale, index) => (
                                        <Line key={ index } obj={ sale } item={ "dashboard_sales" } model={ modelListSales } checkable={ false } openable={ true } />
                                    ))
                                    : <tr><td className={"empty" + (listSales === null ? " loading" : "")} colSpan={modelListSales.length + 1}><p>{(listSales === null ? "Chargement ..." : "Aucune vente")}</p></td></tr>
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
                <Switch>
                    <Route exact path={ "/dashboard/sales/:id" }>
                        <PreviewBox previousLink={ "dashboard" } type={"v2"} />
                    </Route>
                    <Route exact path={ "/dashboard/automaticdrawer/:id" }>
                        <DrawerHistory />
                    </Route>
                </Switch>
            </div>
        </DashboardContext.Provider>
    );
}

export default Dashboard;